jQuery($ => {

    function renderNewsBox(newsBox, isCalendarEvent) {
        if (!isCalendarEvent) {
            newsBox.each((index, news) => {
                const title = $(news).find('.e-news-box__title');
                const desc = $(news).find('.e-news-box__desc');

                const wrapperHeight = $(news).find('.e-news-box__text').height();
                const titleHeight = $(title).outerHeight(true);
                const descHeight = $(desc).outerHeight();
                const height = wrapperHeight - titleHeight;

                if (titleHeight >= wrapperHeight) {
                    const titles = new Dotdotdot($(title)[0], {
                        ellipsis: " [...]",
                        height: wrapperHeight,
                        watch: true,
                        truncate: "word"
                    });
                }

                if (titleHeight < wrapperHeight) {
                    const descriptions = new Dotdotdot($(desc)[0], {
                        ellipsis: " [...]",
                        height,
                        watch: true,
                        truncate: "word",
                    });
                }
            });
        } else {
            newsBox.each((index, news) => {
                const title = $(news).find('.e-news-box__title');
                const desc = $(news).find('.e-news-box__desc');
                const titleHeight = $(title).outerHeight(true);
                const descHeight = $(desc).outerHeight();

                const wrapper = $(news).find('.e-news-box__text');
                const offsetTop = $(wrapper).position().top;
                const wrapperHeight = $(news).height() - offsetTop - 18;
                const height = wrapperHeight - titleHeight;

                if (titleHeight >= wrapperHeight) {
                    const titles = new Dotdotdot($(title)[0], {
                        ellipsis: " [...]",
                        height: wrapperHeight,
                        watch: true,
                        truncate: "word"
                    });
                }

                if (titleHeight < wrapperHeight) {
                    const descriptions = new Dotdotdot($(desc)[0], {
                        ellipsis: " [...]",
                        height,
                        watch: true,
                        truncate: "word",
                    });
                }
            });
        }
    }

    // calendar
    const calendarEvent = $('.e-calendar__event');
    const calendarCard = $('.e-card');
    const calendarPagination = $('.e-calendar--big .e-calendar__pagination--desktop');
    const calendarCardWrap = $('.e-calendar__wrapper');

    $(document).on('click', '.e-calendar__event', function (e) {

        if($(window).width() < 768) {
            const isActive = $(this).hasClass('active');
            const mainCalendar = $(".e-calendar");

            const calendarHeader = $(".e-calendar__header");
            const headerOffset = calendarHeader.offset();
            const thisOffset = $(this).offset();
            const offsetTopResult = thisOffset.top - headerOffset.top - calendarHeader.outerHeight();
            const ResultC = ($(window).width() - 280) / 2;
            const offsetLeftResult = thisOffset.left - ResultC;

            // close active popups cards
            calendarEvent.each(function () {
                $(this).removeClass('active');
            });

            if (isActive) {
                $(this).removeClass('active');
                calendarCardWrap.removeClass("left").removeAttr("style");
                calendarPagination.removeClass("zindex");
            } else {
                $(this).addClass('active');
                calendarPagination.addClass('zindex');

                if ($(window).width() < 768) {
                    $(this).find('.e-calendar__wrapper').css({
                        'top': -offsetTopResult,
                        'left': -offsetLeftResult
                    });
                }
            }

            const cardWrap = $(this).children('.e-calendar__wrapper');
            const cardWrapInner = $(this).find('.e-calendar__wrapper-inner');
            const innerCards = cardWrapInner.children();
            const cardHeight = cardWrapInner.find(".e-card:first").outerHeight();
            if (innerCards.length > 1) {
                innerCards.not(':last').addClass('more');
                cardWrapInner.height(cardHeight + 50);
            }
        } else {
            var urls = $($(this).find('.e-more-button'));

            if (urls.length === 1) {
                window.open(urls.attr('href'), '_blank');
            }
        }
    });

    // select box
    $(document).on('mouseenter', '.e-calendar__event', function (e) {

        if($(window).width() > 767) {
            const isActive = $(this).hasClass('active');
            const mainCalendar = $(".e-calendar");

            const calendarHeader = $(".e-calendar__header");
            const headerOffset = calendarHeader.offset();
            const thisOffset = $(this).offset();
            const offsetTopResult = thisOffset.top - headerOffset.top - calendarHeader.outerHeight();
            const ResultC = ($(window).width() - 280) / 2;
            const offsetLeftResult = thisOffset.left - ResultC;

            // close active popups cards
            calendarEvent.each(function () {
                $(this).removeClass('active');
            });

            $(this).addClass('active');
            calendarPagination.addClass('zindex');

            if ($(window).width() < 768) {
                $(this).find('.e-calendar__wrapper').css({
                    'top': -offsetTopResult,
                    'left': -offsetLeftResult
                });
            }

            const cardWrap = $(this).children('.e-calendar__wrapper');
            const cardWrapInner = $(this).find('.e-calendar__wrapper-inner');
            const innerCards = cardWrapInner.children();
            const cardHeight = cardWrapInner.find(".e-card:first").outerHeight();
            if (innerCards.length > 1) {
                innerCards.not(':last').addClass('more');
                cardWrapInner.height(cardHeight + 50);
            }

            checkIfDisplayOnLeft(e, $(this));
        }
    });

    $(document).on('mouseleave', '.e-calendar__event', function(e) {

        if ($(window).width() > 767) {
            e.preventDefault();
            $(this).removeClass('active');
            $(".e-calendar__event").removeClass("active");
            calendarCardWrap.removeClass("left").removeAttr("style");
            calendarPagination.removeClass("zindex");
        }
    });

    calendarCard.on("click", function(e) {
        e.stopPropagation();
    });

    // popup cards - close on body click
    $(document).on('click', "body", function(e) {
        if (!e.target.classList.contains("active")) {
            $(".e-calendar__event").removeClass("active");
            $('.e-calendar__wrapper').removeClass("left").removeAttr("style");
        }
    });

    function checkIfDisplayOnLeft(event, day) {
        const elOffset = $('body').offset();
        const relX = event.pageX - elOffset.left;
        const windowWidth = $(window).width();
        const result = windowWidth - relX;

        if (result < 340) {
            day.find('.e-calendar__wrapper').addClass('left');
        }
    }

    // $('body').click(function(e) {


    //     if (e.target.classList.contains('e-calendar__event') && result < 340) {
    //         $(this).find('.e-calendar__wrapper').addClass('left');
    //     }
    // });

    // reload calendar (ajax)
    const calendarWrapper = $('#calendarWrapper');

    function reloadCalendar(date, direction) {
        const calHeader = $("#calendarWrapper .e-calendar__header");
        const calCnt = $("#calendarWrapper .e-calendar__month");
        const calArrows = $("#calendarWrapper .e-calendar__arrow");
        const calendarSpin = $("#calendarWrapper .dot-spin-wrapper, .dot-spin-large");
        const calNews = $(".m-news-big__col");
        const calBottomButtons = $("#calendarWrapper .calendarMonth");

        $.ajax({
            url: main.ajax_url,
            type: 'post',
            data: {
                action:         'reload_calendar',
                calendar_page:  ($('body').hasClass('page-template-calendar')) ? 1 : 0,
                direction:      direction,
                current_date:   date
            },
            beforeSend: function() {
                calHeader.addClass('calendar-blocked');
                calCnt.addClass('calendar-blocked');
                calArrows.addClass('calendar-blocked');
                calNews.addClass("calendar-blocked");
                calBottomButtons.addClass("blocked");
                calendarSpin.show();
            },
            complete: function() {
                calHeader.removeClass("calendar-blocked");
                calCnt.removeClass("calendar-blocked");
                calArrows.removeClass("calendar-blocked");
                calNews.removeClass("calendar-blocked");
                calBottomButtons.removeClass("blocked");
                calendarSpin.hide();
            },
            error: function(error) {
                // console.log(error);
            },
            success: function(res) {
                calendarWrapper.html(res);

                const newsBox = calendarWrapper.find('.e-news-box');
                if(newsBox.length > 0) {
                    renderNewsBox(newsBox, true);
                }
            },
        });
    }

    $('body').on('click', '.e-calendar__arrow, .calendarMonth', function(e) {
        e.preventDefault();

        const date = $('.e-calendar__single').first().data('date');
        const direction = $(this).data('direction') || 'next';

        reloadCalendar(date, direction);
    });
});
